import React from "react";

const filters = [
  {
    id: "practice-status",
    label: "Practice Status",
    options: [
      { value: "all", label: "All" },
      { value: "attempted", label: "Attempted" },
      { value: "notAttempted", label: "Not Attempted" },
    ],
  },
  {
    id: "order-by",
    label: "Order By",
    options: [
      { value: "all", label: "All" },
      { value: "newest", label: "Newest" },
      { value: "oldest", label: "Oldest" },
      { value: "az", label: "Title A-Z" },
      { value: "za", label: "Title Z-A" },
      { value: "easyToHard", label: "Easy to Hard" },
      { value: "hardToEasy", label: "Hard to Easy" },
      { value: "mostPracticed", label: "Most Practiced" },
      { value: "leastPracticed", label: "Least Practiced" },
    ],
  },
  {
    id: "badge",
    label: "Badge",
    options: [
      { value: "all", label: "All" },
      { value: "new", label: "New" },
      { value: "weekly", label: "Weekly Prediction" },
      { value: "exam", label: "Exam Question" },
      { value: "mock", label: "Mock Only" },
      { value: "tested", label: "Tested" },
      { value: "untested", label: "Untested" },
    ],
  },
  {
    id: "complexity",
    label: "Complexity",
    options: [
      { value: "all", label: "All" },
      { value: "easy", label: "Easy" },
      { value: "medium", label: "Medium" },
      { value: "hard", label: "Hard" },
    ],
  },
  {
    id: "pagination",
    label: "Pagination",
    hideOnMobile: true,
    options: [
      { value: "10", label: "10 per page" },
      { value: "20", label: "20 per page" },
      { value: "30", label: "30 per page" },
      { value: "50", label: "50 per page" },
      { value: "all", label: "All" },
    ],
  },
];

const FilterHeader = ({ filterValues = {}, onFilterChange = () => {} }) => {
  const handleInputChange = (event) => {
    onFilterChange(event.target.name, event.target.value);
  };

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
      {filters.map((filter) => (
        <label
          key={filter.id}
          htmlFor={filter.id}
          className={`block ${filter.hideOnMobile ? "hidden sm:block" : ""}`}
        >
          <span className="block text-xs font-bold uppercase text-gray-500">
            {filter.label}
          </span>

          <select
            name={filter.id}
            id={filter.id}
            value={filterValues[filter.id] || "all"}
            onChange={handleInputChange}
            className="mt-1.5 h-10 w-full rounded-md border border-slate-200 bg-white px-3 text-sm text-gray-700 shadow-sm outline-none transition focus:border-purple-300 focus:ring-2 focus:ring-purple-100"
          >
            <option value="" disabled>
              Please select
            </option>
            {filter.options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      ))}
    </div>
  );
};

export default FilterHeader;
